/** CSV を作る。表計算ソフトで数式として動かないよう、=・+・-・@（全角も、前に空白があっても）や改行・タブで始まる値の前に ' を付ける */
export function toCsv(rows: string[][]): string {
  const cell = (s: string) => {
    const safe = /^[\s\u3000]*[=+\-@＝＋－＠]|^[\t\r\n]/.test(s.normalize('NFKC')) || /^[\s\u3000]*[＝＋－＠]/.test(s) ? `'${s}` : s;
    return `"${safe.replaceAll('"', '""')}"`;
  };
  return '﻿' + rows.map((r) => r.map(cell).join(',')).join('\r\n');
}
